import {TextField} from "@mui/material";
import React from "react";

const TextFieldObject = ({label, setId, field, entityList, entityField, value}) => {
    return (
        <div>
            <TextField
                autoComplete={"off"}
                key={field}
                sx={{
                    width: '100%',
                    minWidth: {xs: '300px', sm: '360px', md: '400px'},
                    gap: '1.5rem',
                }}
                margin="normal"
                select
                label={label}
                name={field}
                onChange={(e) =>
                    setId(e.target.value)
                }
                defaultValue={value === null ? "" : value}
                SelectProps={{
                    native: true,
                }}
            >
                {entityList.map((entity) => (
                    <option
                        key={entity.id}
                        value={entity.id}>
                        {entity[entityField ? entityField : 'name']}
                    </option>
                ))}
            </TextField>
        </div>
    );
};

export default TextFieldObject;